"use strict";

var _extends = require("/var/vsts/2/s/packages/pharmacy-pricing-tool-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/extends");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var image_asset_1 = require("../../../image-asset/image-asset");

var RuleDetailsCheckbox = function (_super) {
  __extends(RuleDetailsCheckbox, _super);

  function RuleDetailsCheckbox() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleOnCheckboxClick = function () {
      var _a;

      var newValue = !_this.props.propertyValue[_this.props.id];

      var newValues = _extends({}, _this.props.propertyValue, (_a = {}, _a[_this.props.id] = newValue, _a));

      _this.props.onCheckboxClick(newValues);
    };

    _this.renderFilterOption = function (imageName) {
      return react_1.default.createElement(react_native_1.View, {
        key: _this.props.id
      }, react_1.default.createElement(react_native_1.View, {
        style: theme_pricing_system_1.pricingStyles.checkboxContainerView
      }, react_1.default.createElement(react_native_1.Text, {
        style: theme_pricing_system_1.pricingStyles.checkboxLabelText
      }, _this.props.label), react_1.default.createElement(react_native_1.TouchableOpacity, {
        onPress: _this.handleOnCheckboxClick
      }, react_1.default.createElement(image_asset_1.ImageAsset, {
        name: imageName,
        style: [theme_pricing_system_1.pricingStyles.filterOptionCheckboxImageView]
      }))));
    };

    return _this;
  }

  RuleDetailsCheckbox.prototype.render = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.checkboxContainerView
    }, this.renderFilterOption(this.props.isSelected ? 'checkBoxButton' : 'unCheckBoxButton'));
  };

  return RuleDetailsCheckbox;
}(react_1.default.Component);

exports.RuleDetailsCheckbox = RuleDetailsCheckbox;